import React, { useState, useEffect, useCallback, useRef } from 'react';
import './../../App.css';
import './Employees.css';
import {CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import axios from '../../api/apiClient';
import {CreateTable, CreateTableForEmployeeSelect} from './../ManageTable';
import {token, domain} from './../Security';
import loadingSpinner from './../../assets/loading.gif';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
// icon
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AddBoxIcon from '@mui/icons-material/AddBox';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import LayersClearIcon from '@mui/icons-material/LayersClear';
import DownloadIcon from '@mui/icons-material/Download';

function EmployeeReliever({user, isHideSideMenu}) {
    var header = [
        "Regular Employee Id",
        "Regular Employee Name",
        "Reliever Employee Id",
        "Reliever Employee Name",
        "Date",
        "",
    ]
    var accessor = [
        "regularEmployeeEmployeeId",
        "regularEmployeeFullName",
        "relieverEmployeeId",
        "relieverFullName",
        "date",
        "manage"
    ]

    const [showSetting, setShowSetting] = useState(false);
    const settingRef = useRef(null);
    const buttonRef = useRef(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [relieverData, setRelieverData] = useState([]);
    // Retrieve
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by regular employee name");

    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    const [showEmployeeFormReliever, setShowEmployeeFormReliever] = useState(false);
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [employeePersonalInformationIdReliever, setEmployeePersonalInformationIdReliever] = useState("");
    const [employeePersonalInformationFullNameReliever, setEmployeePersonalInformationFullNameReliever] = useState("");
    const [dateAdd, setDateAdd] = useState("");

    const [selectedData, setSelectedData] = useState([]);

    const [showAddForm, setShowAddForm] = useState(false);
    const [showAddBulkForm, setShowAddBulkForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [showDeleteForm, setShowDeleteForm] = useState(false);
    const [showDeleteBulkForm, setShowDeleteBulkForm] = useState(false);

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end
    
    const apiUrl =  domain + "/api/RelieverTagging";

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setRelieverData(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl]);

    useEffect(() => {
        fetchData();
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by regular employee name")
                break;
            case 1:
                setSearchPlaceholder("Search by regular employee id")
                break;
            case 2:
                setSearchPlaceholder("Search by regular employee name")
                break;
            case 3:
                setSearchPlaceholder("Search by reliever employee id")
                break;
            case 4:
                setSearchPlaceholder("Search by reliever employee name")
                break;
            default:
                setSearchPlaceholder("Search by regular employee name")
                break;
        }
    }, [fetchData,filterDataIndex]);
    useEffect(() => {
        if(showEditForm){
            setEmployeePersonalInformationId(selectedData.regularEmployeeId)
            setEmployeePersonalInformationFullName(selectedData.regularEmployeeFullName)
            setEmployeePersonalInformationIdReliever(selectedData.relieverId)
            setEmployeePersonalInformationFullNameReliever(selectedData.relieverFullName)
            setDateAdd(selectedData.date)
        }
    }, [showEditForm, selectedData]);
    
    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            regularEmployeeId: employeePersonalInformationId,
            relieverId: employeePersonalInformationIdReliever,
            date: dateAdd,
            createdDate: new Date(),
            createdById: user.id,
            updatedDate: null,
            updatedById: null
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setEmployeePersonalInformationId("");
            setEmployeePersonalInformationFullName("");
            setEmployeePersonalInformationIdReliever("");
            setEmployeePersonalInformationFullNameReliever("");
            setDateAdd("");
            setShowAddForm(false); // Hide the add form
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAddForm(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        console.log(employeePersonalInformationIdReliever)

        const data = {
            regularEmployeeId: employeePersonalInformationId,
            relieverId: employeePersonalInformationIdReliever,
            date: dateAdd,
            createdDate: selectedData.createdDate,
            createdById: selectedData.createdById,
            updatedDate: new Date(),
            updatedById: user.id
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/${selectedData.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowRequestMessage(true);
            setIsSuccess(true);

            // Reload table data and reset form fields
            await fetchData(""); // Assuming fetchData() fetches the updated data for the table
            setSelectedData([]);
            setShowEditForm(false);
            setEmployeePersonalInformationId("");
            setEmployeePersonalInformationFullName("");
            setEmployeePersonalInformationIdReliever("");
            setEmployeePersonalInformationFullNameReliever("");
            setDateAdd("");
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const handleDelete = async (event) => {
        event.preventDefault();

        const data = {
            regularEmployeeId: selectedData.regularEmployeeId,
            date: selectedData.date,
        };

        try {
            setLoadingRequest(true);
            await axios.post(`${apiUrl}/delete`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            await fetchData(); // Assuming fetchData() fetches the updated data for the table
            setSelectedData([]);
            setShowDeleteForm(false); // Hide the add form
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const handleDeleteAll = async () => {
        try {
            setLoadingRequest(true);
            await axios.delete(`${apiUrl}/bulk-delete`, {
                data: relieverData,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            console.log('Deleted successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
    
            // Reload table data and reset state
            fetchData(); // Assuming fetchData() fetches the updated data for the table
            setShowDeleteBulkForm(false);
        } catch (error) {
            setLoadingRequest(false);
            console.error('There was a problem deleting employee:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
    
            let errorMessage;
            if (error.response) {
                try {
                    errorMessage = JSON.parse(error.response.data).message;
                } catch (e) {
                    errorMessage = 'An error occurred';
                }
            } else {
                errorMessage = error.message || 'An error occurred';
            }
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const handleFilter = (value) => {
        const lowercaseValue = value.toLowerCase();
        setCurrentPage(1);
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.regularEmployeeFullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.regularEmployeeEmployeeId.toString().includes(lowercaseValue)
                );
                break;
            case 2:
                res = filterData.filter((f) =>
                f.regularEmployeeFullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 3:
                res = filterData.filter((f) =>
                f.relieverEmployeeId.toString().includes(lowercaseValue)
                );
                break;
            case 4:
                res = filterData.filter((f) =>
                f.relieverFullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.regularEmployeeFullName.toLowerCase().includes(lowercaseValue)
                );
                break;
        }

        setRelieverData(res);
    };
    const handleSetting = () =>{
        setShowSetting(!showSetting);
    };

    const fetchEmployeeData = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
                return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);

    const uploadEmployeeData = async (file) => {
        setLoadingRequest(true);

        const employees = await fetchEmployeeData();
    
        function excelDateToJSDate(excelDate) {
            const date = new Date((excelDate - 25569) * 86400 * 1000);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }
    
        function convertToDateTimeLocal(dateStr) {
            const datetimeLocal = excelDateToJSDate(dateStr);
            const [day, month, year] = datetimeLocal.split('/');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T00:00:00`;
        }
    
        function sanitizeValue(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return '';
            }
            return value;
        }
    
        function validateData(data) {
            const missingFields = [];

            const idExists = (id) => employees.some(employee => {
                return (employee.id).toString() === id.toString();
            });
    
            data.forEach((item, index) => {
                const missing = [];
                const invalid = [];

                console.log(item)
        
                if (!item.regularEmployeeId) {
                    missing.push('RegularEmployeeId');
                } else if (!idExists(item.regularEmployeeId)) {
                    invalid.push('RegularEmployeeId does not exist in employees');
                }
        
                if (!item.relieverId) {
                    missing.push('RelieverEmployeeId');
                } else if (!idExists(item.relieverId)) {
                    invalid.push('RelieverEmployeeId does not exist in employees');
                }
        
                if (!item.date) missing.push('Date');
        
                if (missing.length > 0) {
                    missingFields.push(`Row ${index + 1}: Missing fields - ${missing.join(', ')}`);
                }
                if (invalid.length > 0) {
                    missingFields.push(`Row ${index + 1}: Invalid fields - ${invalid.join(', ')}`);
                }
            });
        
            if (missingFields.length > 0) {
                console.log(missingFields);
                return {
                    isValid: false,
                    message: `Invalid data in the file. Please check the mandatory fields.\n${missingFields.join('\n')}`
                };
            }
    
            return { isValid: true };
        }
    
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
    
            const parseWorksheet = (worksheet) => {
                return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
            };
    
            const employeeRelieverInformation = parseWorksheet(workbook.Sheets[workbook.SheetNames[0]]);
    
            const bulkData = [];
    
            employeeRelieverInformation.forEach(personalInfo => {
                const filteredInfoRegularEmployee = employees.find(employee => employee.employeeId === (personalInfo.RegularEmployeeId).toString())
                const filteredInfoRelieverEmployee = employees.find(employee => employee.employeeId === (personalInfo.RelieverEmployeeId).toString())

                // i will use the locations, employments etc. here below
                bulkData.push({
                    regularEmployeeId: sanitizeValue(filteredInfoRegularEmployee.id).toString(),
                    relieverId: sanitizeValue(filteredInfoRelieverEmployee.id),
                    date: personalInfo.Date ? convertToDateTimeLocal(personalInfo.Date) : "",
                    createdDate: new Date(),
                    createdById: user.id,
                    updatedDate: null,
                    updatedById: null,
                });
            });

            // console.log('Final bulkData:', JSON.stringify(bulkData, null, 2));
    
            // Validate the bulk data
            const validation = validateData(bulkData);
            if (!validation.isValid) {
                setLoadingRequest(false);
                setShowRequestMessage(true);
                setIsSuccess(false);
                setRequestMessage(validation.message.split('\n').map((line, index) => (
                    <div key={index}>{line}</div>
                )));
                return;
            }
    
            const apiUrl = `${domain}/api/RelieverTagging/bulk`;
    
            try {
                const response = await axios.post(apiUrl, bulkData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                
                await fetchData();

                setShowRequestMessage(true);
                setIsSuccess(true);

                console.log('Upload successful:', response.data);
            } catch (error) {
                setLoadingRequest(false);
                setShowRequestMessage(true);
                setIsSuccess(false);
                console.error('Error:', error);
                const errorMessage = JSON.parse(error.response.request.responseText).message;
                setRequestMessage(errorMessage);
            } finally {
                setLoadingRequest(false);
            }
        };
    
        reader.readAsArrayBuffer(file);
    };
    function handleFileUpload(files) {
        if (!files || files.length === 0) {
            console.error('No files selected');
            return;
        }

        const file = files[0];
        uploadEmployeeData(file);
    }

    const generateDownloadTemplate = useCallback(async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet1 = workbook.addWorksheet('EmployeeReliever');

        const header = [
            'RegularEmployeeId',
            'RegularEmployeeName',
            'RelieverEmployeeId',
            'RelieverEmployeeName',
            'Date',
        ];
        const headerRow = worksheet1.addRow(header);
        worksheet1.columns = [
            { key: 'regularEmployeeId', width: 30 },
            { key: 'regularEmployeeName', width: 30 },
            { key: 'relieverEmployeeId', width: 30 },
            { key: 'relieverEmployeeName', width: 30 },
            { key: 'date', width: 30 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeData = [
            {
                regularEmployeeId: '<EMP1234>',
                regularEmployeeName: '<DELA CRUZ, JUAN>',
                relieverEmployeeId: '<EMP1234>',
                relieverEmployeeName: '<DELA CRUZ, JUAN>',
                date: '<01/01/1993>',
            },
        ];

        employeeData.forEach(employee => {
            worksheet1.addRow(employee);
        });
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Employee_Reliever.xlsx');
    }, []);

    const openAddForm = () =>{
        setShowAddForm(true);
    }
    const openAddBulkForm = () =>{
        setShowAddBulkForm(true);
    }
    const openEditForm = (data) =>{
        setShowEditForm(true);
        setSelectedData(data);
    }
    const openDeleteForm = (data) =>{
        setShowDeleteForm(true);
        setSelectedData(data);
    }
    const openDeleteBulkForm = () =>{
        setShowDeleteBulkForm(true);
    }
    const closeAddForm = () =>{
        setShowAddForm(false);
    }
    const closeAddBulkForm = () =>{
        setShowAddBulkForm(false);
    }
    const closeEditForm = () =>{
        setShowEditForm(false);
    }
    const closeDeleteForm = () =>{
        setShowDeleteForm(false);
    }
    const closeDeleteBulkForm = () =>{
        setShowDeleteBulkForm(false);
    }
    const closeEmployeeForm = () =>{
        setShowEmployeeForm(false);
    }
    const closeEmployeeFormReliever = () =>{
        setShowEmployeeFormReliever(false);
    }

    useEffect(() => {
        var settingIcon = document.getElementById("setting-icon");

        if(showSetting){
            //change the down icon to up
            settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`); // Up Arrow.Path d attribute    
        } else {
            //change the up icon to down
            settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`); // Down Arrow.Path d attribute
        }

        const handleClickOutside = (event) => {
            if (settingRef.current && !settingRef.current.contains(event.target)) {
                if(buttonRef.current && !buttonRef.current.contains(event.target)){
                    setShowSetting(false);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };


    }, [showSetting]);

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="EmployeesTabInfo shadow-xl">
                        <div className="employeesTab-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Personnel >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Employee Reliever"}</span>
                            </div>
                            <div className='row' style={{justifyContent: "space-between", alignItems: "center"}}>
                                <h3>Employees Reliever</h3>
                                <div style={{width:"30%",textAlign:"right"}}>
                                    <button ref={buttonRef} onClick={handleSetting} title="Setting" type="button" className="setting">
                                        <SettingsIcon/>
                                        <KeyboardArrowDownIcon id="setting-icon"/>
                                    </button>
                                    <div ref={settingRef}>
                                        {showSetting && 
                                            <SettingInit
                                            addFunc={openAddForm}
                                            addBulkFunc={openAddBulkForm}
                                            deleteBulkFunc={openDeleteBulkForm}
                                            generateDownloadTemplate={generateDownloadTemplate}
                                            />}
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="employeesTab-body">
                            {Filter(setFilterDataIndex)}
                            <div className="body-top row">
                                <div className="body-top-search">
                                    {CreateSearchBarWithPlaceHolder("", 
                                                                    "mainte-search row", 
                                                                    "mainte-search-icon", 
                                                                    "mainte-search-input", 
                                                                    (e)=>handleFilter(e.target.value), 
                                                                    searchPlaceholder, 
                                                                    SearchIcon)}
                                </div>
                            </div>
                            <div className="employeesTab-table container">
                                <CreateTable
                                    dataList={relieverData}
                                    dataHeader={header}
                                    dataAccessor={accessor}
                                    editHandleClick={openEditForm}
                                    deleteHandleClick={openDeleteForm}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                                {relieverData.length > 0 ? (
                                    <div></div>
                                )
                                :
                                (
                                    <div>
                                    {loading ? (
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                            <img src={loadingSpinner} alt="Loading..." />
                                        </div>
                                    ) : (
                                            <div> {/*<p>No records to display</p>*/}</div>
                                        )
                                    }
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddForm  isOpen={showAddForm} 
                    onClose={closeAddForm}
                    employeePersonalInformationId={employeePersonalInformationId}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
                    employeePersonalInformationIdReliever={employeePersonalInformationIdReliever}
                    setEmployeePersonalInformationIdReliever={setEmployeePersonalInformationIdReliever}
                    employeePersonalInformationFullNameReliever={employeePersonalInformationFullNameReliever}
                    setEmployeePersonalInformationFullNameReliever={setEmployeePersonalInformationFullNameReliever}
                    dateAdd={dateAdd}
                    setDateAdd={setDateAdd}
                    setShowEmployeeForm={setShowEmployeeForm}
                    setShowEmployeeFormReliever={setShowEmployeeFormReliever}
                    handleSubmit={handleSubmit}
            >
            </AddForm>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditForm}
                    employeePersonalInformationId={employeePersonalInformationId}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
                    employeePersonalInformationIdReliever={employeePersonalInformationIdReliever}
                    setEmployeePersonalInformationIdReliever={setEmployeePersonalInformationIdReliever}
                    employeePersonalInformationFullNameReliever={employeePersonalInformationFullNameReliever}
                    setEmployeePersonalInformationFullNameReliever={setEmployeePersonalInformationFullNameReliever}
                    dateAdd={dateAdd}
                    setDateAdd={setDateAdd}
                    setShowEmployeeForm={setShowEmployeeForm}
                    setShowEmployeeFormReliever={setShowEmployeeFormReliever}
                    handleUpdate={handleUpdate}
            >
            </EditForm>
            <UploadForm  isOpen={showAddBulkForm} 
                    onClose={closeAddBulkForm}
                    handleFileUpload={handleFileUpload}
            >
            </UploadForm>
            <DeleteForm  isOpen={showDeleteForm} 
                    onClose={closeDeleteForm}
                    handleDelete={handleDelete}
            >
            </DeleteForm>
            <DeleteBulkForm  isOpen={showDeleteBulkForm} 
                    onClose={closeDeleteBulkForm}
                    handleDelete={handleDeleteAll}
            >
            </DeleteBulkForm>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeePersonalInformationId}
                    setEmployee={setEmployeePersonalInformationFullName}
            >
            </EmployeeSelectForm>
            <EmployeeSelectForm  isOpen={showEmployeeFormReliever} 
                    onClose={closeEmployeeFormReliever}
                    setEmployeeId={setEmployeePersonalInformationIdReliever}
                    setEmployee={setEmployeePersonalInformationFullNameReliever}
            >
            </EmployeeSelectForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function SettingInit({
    addFunc,
    addBulkFunc,
    deleteBulkFunc,
    generateDownloadTemplate
}){
    return(
        <div id='payroll-setting' className="payroll-setting column">
            <div className="payroll-setting-item row" onClick={()=>addFunc(false)}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><AddBoxIcon/></div>
                Add Reliever Tagging
            </div>
            <div className="payroll-setting-item row" onClick={()=>generateDownloadTemplate(false)}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><DownloadIcon/></div>
                Download Template
            </div>
            <div className="payroll-setting-item row"onClick={()=>addBulkFunc()}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><FileUploadIcon/></div>
                Upload Reliever Tagging
            </div>
            <div className="payroll-setting-item row" onClick={()=>deleteBulkFunc(false)}>
                <div style={{margin: "10px 5px 0 5px", color:"#ff4d4d"}}><LayersClearIcon/></div>
                Delete All Reliever Tagging
            </div>
        </div>
    )
}
function AddForm({isOpen, 
    onClose,
    employeePersonalInformationId,
    setEmployeePersonalInformationId,
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
    employeePersonalInformationIdReliever,
    setEmployeePersonalInformationIdReliever,
    employeePersonalInformationFullNameReliever,
    setEmployeePersonalInformationFullNameReliever,
    dateAdd,
    setDateAdd,
    setShowEmployeeForm,
    setShowEmployeeFormReliever,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if (!employeePersonalInformationId 
            || !employeePersonalInformationIdReliever
            || !dateAdd
        ) {
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setEmployeePersonalInformationId("");
        setEmployeePersonalInformationFullName("");
        setEmployeePersonalInformationIdReliever("");
        setEmployeePersonalInformationFullNameReliever("");
        setDateAdd("");
        setErrorState(false);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Reliever</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Regular Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Regular Employee"
                                        value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                    />
                                    <button className="select row"
                                            onClick={()=>setShowEmployeeForm(true)}
                                    ><SearchIcon/></button>
                                </div>
                                <span style={{
                                        visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Reliever Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Reliever Employee"
                                        value={employeePersonalInformationIdReliever ? (employeePersonalInformationFullNameReliever) : employeePersonalInformationIdReliever}
                                    />
                                    <button className="select row"
                                            onClick={()=>setShowEmployeeFormReliever(true)}
                                    ><SearchIcon/></button>
                                </div>
                                <span style={{
                                        visibility: !employeePersonalInformationIdReliever && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date</div>
                            <div className="info-item-input">
                                <DateTimeInput date={dateAdd} setDate={setDateAdd}/>
                            </div>
                            <span style={{
                                    visibility: !dateAdd && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={submit}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditForm({isOpen, 
    onClose,
    employeePersonalInformationId,
    setEmployeePersonalInformationId,
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
    employeePersonalInformationIdReliever,
    setEmployeePersonalInformationIdReliever,
    employeePersonalInformationFullNameReliever,
    setEmployeePersonalInformationFullNameReliever,
    dateAdd,
    setDateAdd,
    setShowEmployeeForm,
    setShowEmployeeFormReliever,
    handleUpdate}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if (!employeePersonalInformationId 
            || !employeePersonalInformationIdReliever
            || !dateAdd
        ) {
            setErrorState(true);
            return;
        }
        handleUpdate(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setEmployeePersonalInformationId("");
        setEmployeePersonalInformationFullName("");
        setEmployeePersonalInformationIdReliever("");
        setEmployeePersonalInformationFullNameReliever("");
        setDateAdd("");
        setErrorState(false);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Reliever</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Regular Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Regular Employee"
                                        value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                    />
                                    <button className="select row"
                                            onClick={()=>setShowEmployeeForm(true)}
                                    ><SearchIcon/></button>
                                </div>
                                <span style={{
                                        visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Reliever Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Reliever Employee"
                                        value={employeePersonalInformationIdReliever ? (employeePersonalInformationFullNameReliever) : employeePersonalInformationIdReliever}
                                    />
                                    <button className="select row"
                                            onClick={()=>setShowEmployeeFormReliever(true)}
                                    ><SearchIcon/></button>
                                </div>
                                <span style={{
                                        visibility: !employeePersonalInformationIdReliever && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date</div>
                            <div className="info-item-input">
                                <DateTimeInput date={dateAdd} setDate={setDateAdd}/>
                            </div>
                            <span style={{
                                    visibility: !dateAdd && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={submit}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DeleteForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to delete this employee reliever?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleDelete}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DeleteBulkForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete All!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to delete all employee reliever?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleDelete}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function UploadForm({isOpen, 
    onClose,
    handleFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
    };

    const [files, setFiles] = useState([]);

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };


    const submit = (e) =>{
        handleFileUpload(files);
        handleClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload Employee Reliever"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>
                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                            <button id="add-family" 
                                className="save row"
                                onClick={(e)=>submit(e)}
                                style={{marginRight:"5px"}}>
                                    UPLOAD
                            </button>
                            <button id="add-family" 
                                className="cancel row"
                                onClick={()=>handleClose()}>
                                    CANCEL
                            </button>
                        </div>)
                    }
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeSelectForm({isOpen, 
    onClose,
    setEmployeeId,
    setEmployee}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        fetchData();
    };

    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");
    const [currentPage, setCurrentPage] = useState(1);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Employee/basic-info/all/active";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }
    const handleFilter = (value) => {
        const lowercaseValue = value.toLowerCase();
        setCurrentPage(1);
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "RegularEmployeeId":
                setFilterDataIndex(1);
                break;
            case "RegularEmployeeName":
                setFilterDataIndex(2);
                break;
            case "RelieverEmployeeId":
                setFilterDataIndex(3);
                break;
            case "RelieverEmployeeName":
                setFilterDataIndex(4);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="RegularEmployeeId">Regular Employee Id</option>
                <option value="RegularEmployeeName">Regular Employee Name</option>
                <option value="RelieverEmployeeId">Reliever Employee Id</option>
                <option value="RelieverEmployeeName">Reliever Employee Name</option>
            </select>
        </div>
    );
};
function DateTimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    let formattedDate = "";

    if(date){
        formattedDate = date.split('T')[0];
    }

    return (
        <div>
            <input
            type="date"
            id={"datetime-"}
            name="datetime"
            value={formattedDate}
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
export default EmployeeReliever
